import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import {
  actionTypes,
  deleteNotifyFailure,
  deleteNotifySuccess,
  getAllRolesFailure,
  getAllRolesSuccess,
  getNotificationsFailure,
  getNotificationsSuccess,
  replayNotifyFailure,
  replayNotifySuccess,
  sendNotifyFailure,
  sendNotifySuccess,
  updateNotifyFailure,
  updateNotifySuccess,
} from "./actions";
import {
  deleteNotify,
  getAllRoles,
  getNotifications,
  postNotify,
  putNotify,
} from "./services";

const fetchGetNotificationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_NOTIFICATIONS),
    mergeMap((action: any) =>
      getNotifications(action.payload.body, action.payload.sortBy).pipe(
        map((response: any) => getNotificationsSuccess(response)),
        catchError((error: any) => of(getNotificationsFailure(error)))
      )
    )
  );

const fetchGetAllRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.NOTIFY_GET_ALL_ROLES),
    mergeMap(() =>
      getAllRoles().pipe(
        map((response: any) => getAllRolesSuccess(response)),
        catchError((error: any) => of(getAllRolesFailure(error)))
      )
    )
  );

const sendNotifyEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SEND_NOTIFY),
    mergeMap((action: any) =>
      postNotify(action.payload).pipe(
        map((response: any) => sendNotifySuccess(response)),
        catchError((error: any) => of(sendNotifyFailure(error)))
      )
    )
  );

const updateNotifyEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_NOTIFY),
    mergeMap((action: any) =>
      putNotify(action.payload).pipe(
        map((response: any) => updateNotifySuccess(response)),
        catchError((error: any) => of(updateNotifyFailure(error)))
      )
    )
  );

const replayNotifyEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REPLAY_NOTIFY),
    mergeMap((action: any) =>
      putNotify(action.payload).pipe(
        map((response: any) => replayNotifySuccess(response)),
        catchError((error: any) => of(replayNotifyFailure(error)))
      )
    )
  );

const deleteNotifyEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DEL_NOTIFY),
    mergeMap((action: any) =>
      deleteNotify(action.payload).pipe(
        map((response: any) => deleteNotifySuccess(response)),
        catchError((error: any) => of(deleteNotifyFailure(error)))
      )
    )
  );

export default [
  fetchGetNotificationsEpic,
  fetchGetAllRolesEpic,
  sendNotifyEpic,
  updateNotifyEpic,
  replayNotifyEpic,
  deleteNotifyEpic,
];
